import { IonButton, IonContent, IonInput, IonPage, IonToast } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";

export default function JoinTeamPage() {
  const { joinTeam } = useAuth();
  const history = useHistory();
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState("");

  async function submit() {
    try {
      await joinTeam(inviteCode);
      history.replace("/app/schedule");
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <IonPage>
      <IonContent fullscreen className="auth-screen">
        <div className="auth-card">
          <h1>Join Team</h1>
          <p>Paste your invite code to activate your account.</p>
          <IonInput
            className="metora-input"
            label="Invite Code"
            labelPlacement="stacked"
            value={inviteCode}
            onIonInput={(event) => setInviteCode(event.detail.value ?? "")}
            placeholder="TEAM_CODE/USER_CODE"
          />
          <IonButton expand="block" onClick={submit}>Join Team</IonButton>
          <IonButton expand="block" fill="clear" onClick={() => history.push("/login")}>Back to Login</IonButton>
        </div>
        <IonToast isOpen={Boolean(error)} message={error} duration={2500} onDidDismiss={() => setError("")} />
      </IonContent>
    </IonPage>
  );
}
